module.exports = __webpack_public_path__ + "img/case_5.89eff1ac.svg";